import { eventbus } from 'packages/eventbus';

export const mentionEventChannel = eventbus<{
	onMembersUpdate: () => void;
}>();
